import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const SignUpPrivacyTrust: React.FC = () => {
  return (
    <div className="bg-white px-6 py-8 shadow sm:rounded-lg w-full max-w-[480px] mt-6">
      {/* Header */}
      <div className="flex justify-center items-center mb-4">
        <ShieldCheckIcon className="h-5 w-5 text-indigo-600 mr-2" />
        <h3 className="text-base font-medium text-gray-900">Your Privacy is Our Priority</h3>
      </div>

      {/* Guarantee statement */}
      <p className="text-center text-gray-600 text-sm mb-8">
        We never store your original face. Guaranteed.
      </p>

      {/* Trust badges */}
      <div className="flex flex-wrap justify-center gap-3">
        <div className="flex items-center px-3 py-1.5 rounded bg-gray-50 border border-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-500 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          <span className="text-xs font-medium text-gray-600">TLS Encrypted</span>
        </div>

        <div className="flex items-center px-3 py-1.5 rounded bg-gray-50 border border-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-indigo-500 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          <span className="text-xs font-medium text-gray-600">GDPR Compliant</span>
        </div>

        <div className="flex items-center px-3 py-1.5 rounded bg-gray-50 border border-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-red-500 mr-1.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          <span className="text-xs font-medium text-gray-600">No Original Face Stored</span>
        </div>
      </div>
    </div>
  );
};

export default SignUpPrivacyTrust;